/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './doctor-especialty.reducer';

export const DoctorEspecialty = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const doctorEspecialtyList = useAppSelector(state => state.doctorEspecialty.entities);
  const loading = useAppSelector(state => state.doctorEspecialty.loading);
  const totalItems = useAppSelector(state => state.doctorEspecialty.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="doctor-especialty-heading" data-cy="DoctorEspecialtyHeading">
        <Translate contentKey="tinyMedicRestApp.doctorEspecialty.home.title">Doctor Especialties</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.doctorEspecialty.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/doctor-especialty/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.doctorEspecialty.home.createLabel">Create new Doctor Especialty</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.doctorEspecialty.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {doctorEspecialtyList && doctorEspecialtyList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('departmentCode')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.departmentCode">Department Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('departmentCode')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('createdDtm')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.createdDtm">Created Dtm</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdDtm')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.createdBy">Created By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th className="hand" onClick={sort('modifiedBy')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.modifiedBy">Modified By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedBy')} />
                </th>
                <th className="hand" onClick={sort('joiningDt')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.joiningDt">Joining Dt</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('joiningDt')} />
                </th>
                <th className="hand" onClick={sort('leavingDt')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.leavingDt">Leaving Dt</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('leavingDt')} />
                </th>
                <th className="hand" onClick={sort('consultationCharge')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.consultationCharge">Consultation Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consultationCharge')} />
                </th>
                <th className="hand" onClick={sort('followupCharge')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.followupCharge">Followup Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('followupCharge')} />
                </th>
                <th className="hand" onClick={sort('followupDay')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.followupDay">Followup Day</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('followupDay')} />
                </th>
                <th className="hand" onClick={sort('followupVisit')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.followupVisit">Followup Visit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('followupVisit')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.doctorId">Doctor Id</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorEspecialty.especialtyCode">Especialty Code</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {doctorEspecialtyList.map((doctorEspecialty, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/doctor-especialty/${doctorEspecialty.id}`} color="link" size="sm">
                      {doctorEspecialty.id}
                    </Button>
                  </td>
                  <td>{doctorEspecialty.departmentCode}</td>
                  <td>{doctorEspecialty.active ? 'true' : 'false'}</td>
                  <td>{doctorEspecialty.createdDtm}</td>
                  <td>{doctorEspecialty.createdBy}</td>
                  <td>{doctorEspecialty.modifiedBy}</td>
                  <td>{doctorEspecialty.joiningDt}</td>
                  <td>{doctorEspecialty.leavingDt}</td>
                  <td>{doctorEspecialty.consultationCharge}</td>
                  <td>{doctorEspecialty.followupCharge}</td>
                  <td>{doctorEspecialty.followupDay}</td>
                  <td>{doctorEspecialty.followupVisit}</td>
                  <td>{doctorEspecialty.timestampentry}</td>
                  <td>{doctorEspecialty.microSec}</td>
                  <td>{doctorEspecialty.lastupdated}</td>
                  <td>{doctorEspecialty.cursor}</td>
                  <td>
                    {doctorEspecialty.doctorId ? (
                      <Link to={`/doctor/${doctorEspecialty.doctorId.id}`}>{doctorEspecialty.doctorId.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {doctorEspecialty.especialtyCode ? (
                      <Link to={`/especialty/${doctorEspecialty.especialtyCode.id}`}>{doctorEspecialty.especialtyCode.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/doctor-especialty/${doctorEspecialty.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/doctor-especialty/${doctorEspecialty.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/doctor-especialty/${doctorEspecialty.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.home.notFound">No Doctor Especialties found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={doctorEspecialtyList && doctorEspecialtyList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DoctorEspecialty;
